import { useCallback, useEffect, useState } from 'react';
import { StatusFetch } from '../utils/enums';
import { Error } from '../types/error';

const useFetch = ({ api, method = 'get', url, data = null, config = null, immediate = true }) => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState<Error | undefined>(undefined);
  const [status, setStatus] = useState<StatusFetch>(immediate
    ? StatusFetch.Pending : StatusFetch.Idle);

  const execute = useCallback(async () => {
    try {
      if (!immediate) setStatus(StatusFetch.Pending);
      setResponse(null);
      setError(null);
      await api[method](url, data, config)
        .then((res) => {
          setResponse(res.data);
          setStatus(StatusFetch.Success);
        })
        .catch((err) => {
          setError(err);
          setStatus(StatusFetch.Error);
        });
    } catch (err) {
      setError(err);
      setStatus(StatusFetch.Error);
    }
  }, [api, method, url, data, config]);

  useEffect(() => {
    if (immediate) {
      execute();
    }
  }, [execute, immediate]);

  return { response, error, status, execute };
};

export default useFetch;
